module.exports = "https://bin.bnbstatic.com/_next/static/images/Quyet Huynh-a0dea07bc8d3e26490efaf24f01e1117.jpg";